"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _clsx = _interopRequireDefault(require("clsx"));

var _axios = _interopRequireDefault(require("axios"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));

var _MessageContext = _interopRequireDefault(require("../../../context/MessageContext"));

var _useAddresses = _interopRequireDefault(require("../../../hooks/useAddresses"));

var _de = _interopRequireDefault(require("../../../locals/de.json"));

var _en = _interopRequireDefault(require("../../../locals/en.json"));

var _it = _interopRequireDefault(require("../../../locals/it.json"));

var _Item = _interopRequireDefault(require("../Item"));

var _List = _interopRequireDefault(require("./List.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Dialog = (0, _component.default)(function () {
  return import("../../Dialog");
});

var List = function List(_ref) {
  var lang = _ref.lang,
      selected = _ref.selected,
      selectable = _ref.selectable,
      onSelect = _ref.onSelect;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;

  var _useContext = (0, _react.useContext)(_MessageContext.default),
      setMessageObj = _useContext.setMessageObj;

  var addresses = (0, _useAddresses.default)();
  var location = (0, _reactRouterDom.useLocation)();
  var navigate = (0, _useLink.default)();
  var hash = location.hash;
  var pathname = location.pathname;

  var _useState = (0, _react.useState)({
    show: false,
    id: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      deleteDialog = _useState2[0],
      setDeleteDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      addressToDelete = _useState4[0],
      setAddressToDelete = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      localAddresses = _useState6[0],
      setLocalAddresses = _useState6[1];

  var css = (0, _List.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(function () {
    setLocalAddresses(addresses);
  }, [addresses]);
  (0, _react.useEffect)(function () {
    if (hash === "") return;
    var now = new Date();
    var hashTimestamp = hash.split(",")[1]; // show Success Message only if time < 10 sec

    if (hashTimestamp) {
      var hashDate = new Date(parseInt(hashTimestamp));

      if (now.getTime() - hashDate.getTime() <= 10000) {
        setMessageObj({
          message: l("reactShop.messages.success.ADDRESS_SAVED"),
          type: "success"
        });
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [hash, l("reactShop.messages.success.ADDRESS_SAVED")]);

  var handleDelete = function handleDelete(id, address) {
    setDeleteDialog({
      show: true,
      id: id ? id : 0
    });
    setAddressToDelete(address);
  };

  var handleClose = function handleClose() {
    setDeleteDialog({
      show: false,
      id: null
    });
  };

  var handleExecuteDelete = function handleExecuteDelete(id) {
    var newAddresses = localAddresses === null || localAddresses === void 0 ? void 0 : localAddresses.filter(function (address) {
      if (id === 0) {
        return address.id !== undefined;
      } else {
        return address.id !== id;
      }
    });
    var loginToken = localStorage.getItem("logintoken");
    var auth = "";

    if (loginToken) {
      auth = "Bearer ".concat(loginToken);
    } // delete Address


    _axios.default.delete("".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CustomerApi/AddressREST.api"), {
      headers: {
        Authorization: auth,
        "Content-Type": "application/json"
      },
      data: {
        id: id
      }
    }).then(function (response) {
      var _response$data = response.data;
      _response$data = _response$data === void 0 ? {} : _response$data;
      var msg = _response$data.msg;

      if (msg === "ok") {
        setMessageObj({
          message: /*#__PURE__*/_react.default.createElement(_Local.default, {
            identifier: "reactShop.messages.success.ADDRESS_DELETED",
            l: l
          }),
          type: "success"
        });
      }
    });

    setLocalAddresses(newAddresses);
    setDeleteDialog({
      show: false,
      id: null
    });
  };

  var handleEdit = function handleEdit(id) {
    navigate(pathname + "/edit/" + (id ? id : 0));
  };

  var handleNew = function handleNew() {
    navigate(pathname + "/new");
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.list, "mco-shop-addresses")
  }, /*#__PURE__*/_react.default.createElement(_Item.default, {
    lang: lang,
    newItem: true,
    onClickNew: handleNew
  }), localAddresses === null || localAddresses === void 0 ? void 0 : localAddresses.map(function (address, counter) {
    var _address$id = address.id,
        id = _address$id === void 0 ? 0 : _address$id;
    return /*#__PURE__*/_react.default.createElement(_Item.default, {
      avoidDelete: localAddresses.length === 1,
      data: address,
      key: counter,
      lang: lang,
      selected: selected === id,
      selectable: selectable,
      onDelete: handleDelete,
      onEdit: handleEdit,
      onSelect: onSelect
    });
  }), /*#__PURE__*/_react.default.createElement(Dialog, {
    buttonPrimary: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.delete",
      l: l
    }),
    buttonPrimaryAction: function buttonPrimaryAction() {
      return handleExecuteDelete(deleteDialog.id);
    },
    buttonSecondary: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.cancel",
      l: l
    }),
    buttonSecondaryAction: handleClose,
    handleClose: handleClose,
    openDialog: deleteDialog.show,
    title: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.deleteHeadline",
      l: l
    }),
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.deleteText",
      l: l
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: addressToDelete
      }
    }))
  }));
};

var _default = List;
exports.default = _default;